import { Image } from 'react-native'

const images = {
  countryRoamingBackground: Image.resolveAssetSource(require('../Images/HIFI/CountryBackground.png')),
  backWhite: Image.resolveAssetSource(require('../Images/Icons/back_white.png')),
  closeWhite: Image.resolveAssetSource(require('../Images/Icons/close_white.png')),
  roaming: Image.resolveAssetSource(require('../Images/Icons/darkMode/airplane.png')),
  warning: Image.resolveAssetSource(require('../Images/Icons/warning.png')),
  success: Image.resolveAssetSource(require('../Images/Icons/success.png')),
  ic_refreshRed: Image.resolveAssetSource(require('../Images/Icons/icRefreshRed.png')),
  // ic_roaming_white: Image.resolveAssetSource(require('../Images/Icons/airplane_white.png')),


  countrySelect: Image.resolveAssetSource(require('../Images/Icons/countrySelect.png')),
  netherlands: Image.resolveAssetSource(require('../Images/HIFI/Netherlands.png')),
  smsTextWhite: Image.resolveAssetSource(require('../Images/Icons/sms_text.png')),
  callLogWhite: Image.resolveAssetSource(require('../Images/Icons/call-log.png')),
  dataSharingWhite: Image.resolveAssetSource(require('../Images/Icons/data_sharing.png')),
  airplane: Image.resolveAssetSource(require('../Images/Icons/airplane.png')),
  rightArrowRed: Image.resolveAssetSource(require('../Images/Icons/rightArrowRed.png')),
  phone: Image.resolveAssetSource(require('../Images/Icons/phone.png')),
  westernBalkan: Image.resolveAssetSource(require('../Images/HIFI/Western_Balkans.png')),


  // Flags
  defaultFlag: Image.resolveAssetSource(require('../Images/Icons/countryFlags/defaultFlag.png')),
  AE: Image.resolveAssetSource(require('../Images/FlagIcons/AE.png')),
  AF: Image.resolveAssetSource(require('../Images/FlagIcons/AF.png')),
  AG: Image.resolveAssetSource(require('../Images/FlagIcons/AG.png')),
  AI: Image.resolveAssetSource(require('../Images/FlagIcons/AI.png')),
  AM: Image.resolveAssetSource(require('../Images/FlagIcons/AM.png')),
  AO: Image.resolveAssetSource(require('../Images/FlagIcons/AO.png')),
  AR: Image.resolveAssetSource(require('../Images/FlagIcons/AR.png')),
  AT: Image.resolveAssetSource(require('../Images/FlagIcons/AT.png')),
  AU: Image.resolveAssetSource(require('../Images/FlagIcons/AU.png')),
  AW: Image.resolveAssetSource(require('../Images/FlagIcons/AW.png')),
  AZ: Image.resolveAssetSource(require('../Images/FlagIcons/AZ.png')),
  BA: Image.resolveAssetSource(require('../Images/FlagIcons/BA.png')),
  BB: Image.resolveAssetSource(require('../Images/FlagIcons/BB.png')),
  BD: Image.resolveAssetSource(require('../Images/FlagIcons/BD.png')),
  BE: Image.resolveAssetSource(require('../Images/FlagIcons/BE.png')),
  BF: Image.resolveAssetSource(require('../Images/FlagIcons/BF.png')),
  BG: Image.resolveAssetSource(require('../Images/FlagIcons/BG.png')),
  BH: Image.resolveAssetSource(require('../Images/FlagIcons/BH.png')),
  BI: Image.resolveAssetSource(require('../Images/FlagIcons/BI.png')),
  BJ: Image.resolveAssetSource(require('../Images/FlagIcons/BJ.png')),
  BM: Image.resolveAssetSource(require('../Images/FlagIcons/BM.png')),
  BN: Image.resolveAssetSource(require('../Images/FlagIcons/BN.png')),
  BO: Image.resolveAssetSource(require('../Images/FlagIcons/BO.png')),
  BQ: Image.resolveAssetSource(require('../Images/FlagIcons/BQ.png')),
  BR: Image.resolveAssetSource(require('../Images/FlagIcons/BR.png')),
  BS: Image.resolveAssetSource(require('../Images/FlagIcons/BS.png')),
  BT: Image.resolveAssetSource(require('../Images/FlagIcons/BT.png')),
  BW: Image.resolveAssetSource(require('../Images/FlagIcons/BW.png')),
  BY: Image.resolveAssetSource(require('../Images/FlagIcons/BY.png')),
  BZ: Image.resolveAssetSource(require('../Images/FlagIcons/BZ.png')),
  CA: Image.resolveAssetSource(require('../Images/FlagIcons/CA.png')),
  CD: Image.resolveAssetSource(require('../Images/FlagIcons/CD.png')),
  CF: Image.resolveAssetSource(require('../Images/FlagIcons/CF.png')),
  CH: Image.resolveAssetSource(require('../Images/FlagIcons/CH.png')),
  CI: Image.resolveAssetSource(require('../Images/FlagIcons/CI.png')),
  CK: Image.resolveAssetSource(require('../Images/FlagIcons/CK.png')),
  CL: Image.resolveAssetSource(require('../Images/FlagIcons/CL.png')),
  CM: Image.resolveAssetSource(require('../Images/FlagIcons/CM.png')),
  CN: Image.resolveAssetSource(require('../Images/FlagIcons/CN.png')),
  CO: Image.resolveAssetSource(require('../Images/FlagIcons/CO.png')),
  CR: Image.resolveAssetSource(require('../Images/FlagIcons/CR.png')),
  CU: Image.resolveAssetSource(require('../Images/FlagIcons/CU.png')),
  CV: Image.resolveAssetSource(require('../Images/FlagIcons/CV.png')),
  CW: Image.resolveAssetSource(require('../Images/FlagIcons/CW.png')),
  CY: Image.resolveAssetSource(require('../Images/FlagIcons/CY.png')),
  CZ: Image.resolveAssetSource(require('../Images/FlagIcons/CZ.png')),
  DE: Image.resolveAssetSource(require('../Images/FlagIcons/DE.png')),
  DJ: Image.resolveAssetSource(require('../Images/FlagIcons/DJ.png')),
  DK: Image.resolveAssetSource(require('../Images/FlagIcons/DK.png')),
  DM: Image.resolveAssetSource(require('../Images/FlagIcons/DM.png')),
  DO: Image.resolveAssetSource(require('../Images/FlagIcons/DO.png')),
  DZ: Image.resolveAssetSource(require('../Images/FlagIcons/DZ.png')),
  EC: Image.resolveAssetSource(require('../Images/FlagIcons/EC.png')),
  EE: Image.resolveAssetSource(require('../Images/FlagIcons/EE.png')),
  EG: Image.resolveAssetSource(require('../Images/FlagIcons/EG.png')),
  ES: Image.resolveAssetSource(require('../Images/FlagIcons/ES.png')),
  ET: Image.resolveAssetSource(require('../Images/FlagIcons/ET.png')),
  FI: Image.resolveAssetSource(require('../Images/FlagIcons/FI.png')),
  FJ: Image.resolveAssetSource(require('../Images/FlagIcons/FJ.png')),
  FO: Image.resolveAssetSource(require('../Images/FlagIcons/FO.png')),
  FR: Image.resolveAssetSource(require('../Images/FlagIcons/FR.png')),
  GA: Image.resolveAssetSource(require('../Images/FlagIcons/GA.png')),
  GB: Image.resolveAssetSource(require('../Images/FlagIcons/GB.png')),
  GD: Image.resolveAssetSource(require('../Images/FlagIcons/GD.png')),
  GE: Image.resolveAssetSource(require('../Images/FlagIcons/GE.png')),
  GF: Image.resolveAssetSource(require('../Images/FlagIcons/GF.png')),
  GG: Image.resolveAssetSource(require('../Images/FlagIcons/GG.png')),
  GH: Image.resolveAssetSource(require('../Images/FlagIcons/GH.png')),
  GL: Image.resolveAssetSource(require('../Images/FlagIcons/GL.png')),
  GM: Image.resolveAssetSource(require('../Images/FlagIcons/GM.png')),
  GP: Image.resolveAssetSource(require('../Images/FlagIcons/GP.png')),
  GQ: Image.resolveAssetSource(require('../Images/FlagIcons/GQ.png')),
  GR: Image.resolveAssetSource(require('../Images/FlagIcons/GR.png')),
  GT: Image.resolveAssetSource(require('../Images/FlagIcons/GT.png')),
  GU: Image.resolveAssetSource(require('../Images/FlagIcons/GU.png')),
  GY: Image.resolveAssetSource(require('../Images/FlagIcons/GY.png')),
  HK: Image.resolveAssetSource(require('../Images/FlagIcons/HK.png')),
  HN: Image.resolveAssetSource(require('../Images/FlagIcons/HN.png')),
  HR: Image.resolveAssetSource(require('../Images/FlagIcons/HR.png')),
  HT: Image.resolveAssetSource(require('../Images/FlagIcons/HT.png')),
  HU: Image.resolveAssetSource(require('../Images/FlagIcons/HU.png')),
  ID: Image.resolveAssetSource(require('../Images/FlagIcons/ID.png')),
  IE: Image.resolveAssetSource(require('../Images/FlagIcons/IE.png')),
  IL: Image.resolveAssetSource(require('../Images/FlagIcons/IL.png')),
  IN: Image.resolveAssetSource(require('../Images/FlagIcons/IN.png')),
  IQ: Image.resolveAssetSource(require('../Images/FlagIcons/IQ.png')),
  IR: Image.resolveAssetSource(require('../Images/FlagIcons/IR.png')),
  IS: Image.resolveAssetSource(require('../Images/FlagIcons/IS.png')),
  IT: Image.resolveAssetSource(require('../Images/FlagIcons/IT.png')),
  JE: Image.resolveAssetSource(require('../Images/FlagIcons/JE.png')),
  JM: Image.resolveAssetSource(require('../Images/FlagIcons/JM.png')),
  JO: Image.resolveAssetSource(require('../Images/FlagIcons/JO.png')),
  JP: Image.resolveAssetSource(require('../Images/FlagIcons/JP.png')),
  KE: Image.resolveAssetSource(require('../Images/FlagIcons/KE.png')),
  KG: Image.resolveAssetSource(require('../Images/FlagIcons/KG.png')),
  KH: Image.resolveAssetSource(require('../Images/FlagIcons/KH.png')),
  KN: Image.resolveAssetSource(require('../Images/FlagIcons/KN.png')),
  KR: Image.resolveAssetSource(require('../Images/FlagIcons/KR.png')),
  KW: Image.resolveAssetSource(require('../Images/FlagIcons/KW.png')),
  KY: Image.resolveAssetSource(require('../Images/FlagIcons/KY.png')),
  KZ: Image.resolveAssetSource(require('../Images/FlagIcons/KZ.png')),
  LA: Image.resolveAssetSource(require('../Images/FlagIcons/LA.png')),
  LB: Image.resolveAssetSource(require('../Images/FlagIcons/LB.png')),
  LC: Image.resolveAssetSource(require('../Images/FlagIcons/LC.png')),
  LI: Image.resolveAssetSource(require('../Images/FlagIcons/LI.png')),
  LK: Image.resolveAssetSource(require('../Images/FlagIcons/LK.png')),
  LR: Image.resolveAssetSource(require('../Images/FlagIcons/LR.png')),
  LS: Image.resolveAssetSource(require('../Images/FlagIcons/LS.png')),
  LT: Image.resolveAssetSource(require('../Images/FlagIcons/LT.png')),
  LU: Image.resolveAssetSource(require('../Images/FlagIcons/LU.png')),
  LV: Image.resolveAssetSource(require('../Images/FlagIcons/LV.png')),
  LY: Image.resolveAssetSource(require('../Images/FlagIcons/LY.png')),
  MA: Image.resolveAssetSource(require('../Images/FlagIcons/MA.png')),
  MC: Image.resolveAssetSource(require('../Images/FlagIcons/MC.png')),
  MD: Image.resolveAssetSource(require('../Images/FlagIcons/MD.png')),
  ME: Image.resolveAssetSource(require('../Images/FlagIcons/ME.png')),
  MG: Image.resolveAssetSource(require('../Images/FlagIcons/MG.png')),
  MK: Image.resolveAssetSource(require('../Images/FlagIcons/MK.png')),
  ML: Image.resolveAssetSource(require('../Images/FlagIcons/ML.png')),
  MM: Image.resolveAssetSource(require('../Images/FlagIcons/MM.png')),
  MN: Image.resolveAssetSource(require('../Images/FlagIcons/MN.png')),
  MO: Image.resolveAssetSource(require('../Images/FlagIcons/MO.png')),
  MR: Image.resolveAssetSource(require('../Images/FlagIcons/MR.png')),
  MT: Image.resolveAssetSource(require('../Images/FlagIcons/MT.png')),
  MU: Image.resolveAssetSource(require('../Images/FlagIcons/MU.png')),
  MV: Image.resolveAssetSource(require('../Images/FlagIcons/MV.png')),
  MW: Image.resolveAssetSource(require('../Images/FlagIcons/MW.png')),
  MX: Image.resolveAssetSource(require('../Images/FlagIcons/MX.png')),
  MY: Image.resolveAssetSource(require('../Images/FlagIcons/MY.png')),
  MZ: Image.resolveAssetSource(require('../Images/FlagIcons/MZ.png')),
  NA: Image.resolveAssetSource(require('../Images/FlagIcons/NA.png')),
  NE: Image.resolveAssetSource(require('../Images/FlagIcons/NE.png')),
  NG: Image.resolveAssetSource(require('../Images/FlagIcons/NG.png')),
  NI: Image.resolveAssetSource(require('../Images/FlagIcons/NI.png')),
  NL: Image.resolveAssetSource(require('../Images/FlagIcons/NL.png')),
  NO: Image.resolveAssetSource(require('../Images/FlagIcons/NO.png')),
  NP: Image.resolveAssetSource(require('../Images/FlagIcons/NP.png')),
  NZ: Image.resolveAssetSource(require('../Images/FlagIcons/NZ.png')),
  OM: Image.resolveAssetSource(require('../Images/FlagIcons/OM.png')),
  PA: Image.resolveAssetSource(require('../Images/FlagIcons/PA.png')),
  PE: Image.resolveAssetSource(require('../Images/FlagIcons/PE.png')),
  PF: Image.resolveAssetSource(require('../Images/FlagIcons/PF.png')),
  PG: Image.resolveAssetSource(require('../Images/FlagIcons/PG.png')),
  PH: Image.resolveAssetSource(require('../Images/FlagIcons/PH.png')),
  PK: Image.resolveAssetSource(require('../Images/FlagIcons/PK.png')),
  PL: Image.resolveAssetSource(require('../Images/FlagIcons/PL.png')),
  PS: Image.resolveAssetSource(require('../Images/FlagIcons/PS.png')),
  PT: Image.resolveAssetSource(require('../Images/FlagIcons/PT.png')),
  PY: Image.resolveAssetSource(require('../Images/FlagIcons/PY.png')),
  QA: Image.resolveAssetSource(require('../Images/FlagIcons/QA.png')),
  RO: Image.resolveAssetSource(require('../Images/FlagIcons/RO.png')),
  RS: Image.resolveAssetSource(require('../Images/FlagIcons/RS.png')),
  RU: Image.resolveAssetSource(require('../Images/FlagIcons/RU.png')),
  RW: Image.resolveAssetSource(require('../Images/FlagIcons/RW.png')),
  SA: Image.resolveAssetSource(require('../Images/FlagIcons/SA.png')),
  SB: Image.resolveAssetSource(require('../Images/FlagIcons/SB.png')),
  SC: Image.resolveAssetSource(require('../Images/FlagIcons/SC.png')),
  SE: Image.resolveAssetSource(require('../Images/FlagIcons/SE.png')),
  SG: Image.resolveAssetSource(require('../Images/FlagIcons/SG.png')),
  SI: Image.resolveAssetSource(require('../Images/FlagIcons/SI.png')),
  SK: Image.resolveAssetSource(require('../Images/FlagIcons/SK.png')),
  SL: Image.resolveAssetSource(require('../Images/FlagIcons/SL.png')),
  SM: Image.resolveAssetSource(require('../Images/FlagIcons/SM.png')),
  SN: Image.resolveAssetSource(require('../Images/FlagIcons/SN.png')),
  SR: Image.resolveAssetSource(require('../Images/FlagIcons/SR.png')),
  ST: Image.resolveAssetSource(require('../Images/FlagIcons/ST.png')),
  SV: Image.resolveAssetSource(require('../Images/FlagIcons/SV.png')),
  TC: Image.resolveAssetSource(require('../Images/FlagIcons/TC.png')),
  TD: Image.resolveAssetSource(require('../Images/FlagIcons/TD.png')),
  TH: Image.resolveAssetSource(require('../Images/FlagIcons/TH.png')),
  TJ: Image.resolveAssetSource(require('../Images/FlagIcons/TJ.png')),
  TL: Image.resolveAssetSource(require('../Images/FlagIcons/TL.png')),
  TN: Image.resolveAssetSource(require('../Images/FlagIcons/TN.png')),
  TO: Image.resolveAssetSource(require('../Images/FlagIcons/TO.png')),
  TR: Image.resolveAssetSource(require('../Images/FlagIcons/TR.png')),
  TT: Image.resolveAssetSource(require('../Images/FlagIcons/TT.png')),
  TW: Image.resolveAssetSource(require('../Images/FlagIcons/TW.png')),
  TZ: Image.resolveAssetSource(require('../Images/FlagIcons/TZ.png')),
  UA: Image.resolveAssetSource(require('../Images/FlagIcons/UA.png')),
  UG: Image.resolveAssetSource(require('../Images/FlagIcons/UG.png')),
  US: Image.resolveAssetSource(require('../Images/FlagIcons/US.png')),
  UY: Image.resolveAssetSource(require('../Images/FlagIcons/UY.png')),
  UZ: Image.resolveAssetSource(require('../Images/FlagIcons/UZ.png')),
  VC: Image.resolveAssetSource(require('../Images/FlagIcons/VC.png')),
  VE: Image.resolveAssetSource(require('../Images/FlagIcons/VE.png')),
  VG: Image.resolveAssetSource(require('../Images/FlagIcons/VG.png')),
  VN: Image.resolveAssetSource(require('../Images/FlagIcons/VN.png')),
  VU: Image.resolveAssetSource(require('../Images/FlagIcons/VU.png')),
  WS: Image.resolveAssetSource(require('../Images/FlagIcons/WS.png')),
  XK: Image.resolveAssetSource(require('../Images/FlagIcons/XK.png')),
  YE: Image.resolveAssetSource(require('../Images/FlagIcons/YE.png')),
  ZA: Image.resolveAssetSource(require('../Images/FlagIcons/ZA.png')),
  ZM: Image.resolveAssetSource(require('../Images/FlagIcons/ZM.png')),
  ZW: Image.resolveAssetSource(require('../Images/FlagIcons/ZW.png')),
  
}

export default images

